import styled from "styled-components";
import ReactApexChart from "react-apexcharts";

export const EChartWrapper = styled(ReactApexChart)`
  background: linear-gradient(62deg, #00369e 0%, #005cfd 53%, #a18dff 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 4px 6px #0000001f;
  border-radius: 8px;
`;
